export default __webpack_public_path__ + "static/media/orient.cb1b4efd.png";